import events from './config/baseEvents';

import FlightsCarouselBaseController from './controllers/flights/flightsCarouselBaseCtrl';
import FlightsClearFiltersBaseController from './controllers/flights/flightsClearFiltersBaseCtrl';
import FlightsHeaderBaseController from './controllers/flights/flightsHeaderBaseCtrl';
import FlightsListBaseController from './controllers/flights/flightsListBaseCtrl';
import FlightsSearchFormBaseController from './controllers/flights/flightsSearchFormBaseCtrl';
import OnewayBaseController from './controllers/flights/onewayBaseCtrl';
import RulesBaseController from './controllers/flights/rulesBaseCtrl';
import TypeaheadBaseController from './controllers/flights/typeaheadBaseCtrl';
import MapButtonCtrl from './controllers/mapButtonCtrl';

import UkrailResultsBaseController from './controllers/flights/ukrailResultsBaseCtrl';

import UkRailHeaderBaseController from './controllers/ukrail/railHeaderBaseCtrl';
import UkRailOnewayBaseController from './controllers/ukrail/railonewayBaseCtrl';
import UkRailRoundtripBaseController from './controllers/ukrail/railRoundtripBaseCtrl';
import UkRailSearchFormBaseController from './controllers/ukrail/railSearchFormBaseCtrl';
import TypeAheadRailBaseController from './controllers/ukrail/typeaheadRailBaseCtrl';

import UkRailResultBaseController from './controllers/ukrail/ukrailResultBaseCtrl';

import FlightMoreOptions from './directives/ktFlightMoreOptions.directive';
import RailMoreOptions from './directives/ktRailMoreOptions.directive';
import FlightTravellers from './directives/ktFlightTravellers.directive';

import FlightLabelFilter from './filters/flightLabel.filter';

import FlightsApiFactory from './services/flightsApi';
import RailsApiService from './services/railsApiService';
import FlightSearchParamsFactory from './services/flightSearchParams';
import RailSearchParamsFactory from './services/railSearchParams';
import FlightsFactory from './services/flightsFactory';
import RailsFactory from './services/railsFactory';
import FlightsUtilsFactory from './services/flightsUtils';
import RailsUtilsFactory from './services/railsUtils';

const MODULE_NAME = 'App.Base';
const module = angular
    .module(MODULE_NAME, [
        'app.constants',
    ])
    .constant('baseEvents', events)
    .controller('FlightsCarouselBaseController', FlightsCarouselBaseController)
    .controller('FlightsClearFiltersBaseController', FlightsClearFiltersBaseController)
    .controller('FlightsHeaderBaseController', FlightsHeaderBaseController)
    .controller('FlightsListBaseController', FlightsListBaseController)
    .controller('FlightsSearchFormBaseController', FlightsSearchFormBaseController)
    .controller('OnewayBaseController', OnewayBaseController)
    .controller('RulesBaseController', RulesBaseController)
    .controller('TypeaheadBaseController', TypeaheadBaseController)
    .controller('MapButtonController', MapButtonCtrl)
    .controller('RailHeaderBaseController', UkRailHeaderBaseController)
    .controller('RailonewayBaseController', UkRailOnewayBaseController)
    .controller('RailRoundtripBaseController', UkRailRoundtripBaseController)
    .controller('RailSearchFormBaseController', UkRailSearchFormBaseController)
    .controller('UkrailResultsBaseController', UkrailResultsBaseController)
    .controller('TypeaheadRailBaseController', TypeAheadRailBaseController)
    .controller('UkrailResultBaseController', UkRailResultBaseController)
    .directive('ktFlightMoreOptions', FlightMoreOptions)
    .directive('ktRailMoreOptions', RailMoreOptions)
    .directive('ktFlightTravellers', FlightTravellers)
    .factory('flightsApiService', FlightsApiFactory)
    .factory('railsApiService', RailsApiService)
    .factory('flightSearchParams', FlightSearchParamsFactory)
    .factory('RailSearchParams', RailSearchParamsFactory)
    .factory('FtFactory', FlightsFactory)
    .factory('rtFactory', RailsFactory)
    .factory('flightsUtils', FlightsUtilsFactory)
    .filter('flightLabel', FlightLabelFilter)
    .factory('railsUtils', RailsUtilsFactory);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/base/base-module.js